import React, { useState, useRef } from 'react';
import Card from 'react-credit-cards';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/credit-card.scss';
import { motion } from 'framer-motion';
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
} from './utils';
import 'react-credit-cards/es/styles-compiled.css';

const CreditCardForm = ({ setInputs,  handleSubmit }) => {
    const [formData, setFormData] = useState(null);
    const [state, setState] = useState({
        number: '',
        name: '',
        expiry: '',
        cvc: '',
        issuer: '',
        focused: '',
    });
    
    const formRef = useRef(null);

    const handleCallback = ({ issuer }, isValid) => {
        if (isValid) {
            setState(prevState => ({ ...prevState, issuer }));
        }
    };

    const handleInputFocus = (event) => {
        setState(prevState => ({
            ...prevState,
            focused: event.target.name,
        }));
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        let formattedValue = value;

        if (name === 'number') {
            formattedValue = formatCreditCardNumber(value);
        } else if (name === 'expiry') {
            formattedValue = formatExpirationDate(value);
        } else if (name === 'cvc') {
            formattedValue = formatCVC(value);
        }

        setInputs(prevInputs => ({ ...prevInputs, [name]: formattedValue }));
        setState(prevState => ({ ...prevState, [name]: formattedValue }));
    };

    const handleSubmitForm = (e) => {
        e.preventDefault();
        const { issuer } = state;
        const formData = [...e.target.elements]
            .filter((element) => element.name)
            .reduce((acc, element) => {
                acc[element.name] = element.value;
                return acc;
            }, {});

        setFormData(formData);
        formRef.current.reset();
    };

    const { number, name, expiry, cvc, focused, issuer } = state;

    return (
        <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
        >
            <div className="App-payment">
                <div className="card_flex">
                    <Card
                        number={number}
                        name={name}
                        expiry={expiry}
                        cvc={cvc}
                        focused={focused}
                        callback={handleCallback}
                    />
                    <form className="mt-5 w-75 m-auto" ref={formRef} onSubmit={handleSubmitForm}>
                        <div className="form-group">
                            <input
                                type="text"
                                name="number"
                                className="form-control"
                                placeholder="卡號"
                                pattern="[\d| ]{16,22}"
                                maxLength="19"
                                onChange={handleInputChange}
                                onFocus={handleInputFocus}
                            />
                        </div>
                        <div className="form-group mt-2">
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                placeholder="姓名"
                                onChange={handleInputChange}
                                onFocus={handleInputFocus}
                            />
                        </div>
                        <div className="row mt-2">
                            <div className="col-6">
                                <input
                                    type="tel"
                                    name="expiry"
                                    className="form-control"
                                    placeholder="有效期限"
                                    pattern="\d\d/\d\d"
                                    onChange={handleInputChange}
                                    onFocus={handleInputFocus}
                                />
                            </div>
                            <div className="col-6">
                                <input
                                    type="tel"
                                    name="cvc"
                                    className="form-control"
                                    placeholder="安全碼"
                                    maxLength="3"
                                    pattern="\d{3,4}"
                                    onChange={handleInputChange}
                                    onFocus={handleInputFocus}
                                />
                            </div>
                        </div>
                        <input type="hidden" name="issuer" value={issuer} />
                        <div className="form-actions mt-5">
                            <button className="btn btn-primary" onClick={handleSubmit}>
                                送出
                            </button>
                        </div>
                    </form>
                </div>
                
            </div>
        </motion.div>
    );
};

export default CreditCardForm;